import React, { useEffect, useState } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/database";
import "firebase/compat/storage";

const Appointment = () => {
  const [fname, setfName] = useState("");
  const [lname, setlName] = useState("");
  const [date, setDate] = useState("");
  const [pnumber, setPnumber] = useState("");
  const [message, setMessage] = useState("");
  const [branch, setBranch] = useState("");
  const [time, setTime] = useState("");
  const [timeOptions, setTimeOptions] = useState([]);
  const [latestId, setLatestId] = useState(0);
  const [feedbackMessage, setFeedbackMessage] = useState("");

  useEffect(() => {
    const fetchLatestId = async () => {
      try {
        const snapshot = await firebase
          .database()
          .ref("Appointment Form")
          .orderByChild("Appointment_id")
          .limitToLast(1)
          .once("value");
        if (snapshot.exists()) {
          const latestEntry = snapshot.val();
          const latestIdValue = Object.values(latestEntry)[0].Appointment_id;
          setLatestId(latestIdValue);
        } else {
          setLatestId(0);
        }
      } catch (error) {
        console.error("Error fetching latest ID:", error);
      }
    };

    fetchLatestId();
  }, []);

  useEffect(() => {
    if (branch === "Medavakkam") {
      setTimeOptions([
        "10:00 am to 10:30 am",
        "10:30 am to 11:00 am",
        "11:00 am to 11:30 am",
        "11:30 am to 12:00 pm",
        "12:00 pm to 12:30 pm",
        "12:30 pm to 01:00 pm",
        "01:00 pm to 01:30 pm",
        "01:30 pm to 02:00 pm",
        "02:00 pm to 02:30 pm",
        "02:30 pm to 03:00 pm",
        "03:00 pm to 03:30 pm",
        "03:30 pm to 04:00 pm",
        "04:00 pm to 04:30 pm",
        "04:30 pm to 05:00 pm",
        "05:00 pm to 05:30 pm",
        "05:30 pm to 06:00 pm",
        "06:00 pm to 06:30 pm",
        "06:30 pm to 07:00 pm",
        "07:00 pm to 07:30 pm",
        "07:30 pm to 08:00 pm",
        "08:00 pm to 08:30 pm",
      ]);
    } else if (branch === "Sholinganallur") {
      setTimeOptions([
        "10:00 am to 10:30 am",
        "10:30 am to 11:00 am",
        "11:00 am to 11:30 am",
        "11:30 am to 12:00 pm",
        "12:00 pm to 12:30 pm",
        "12:30 pm to 01:00 pm",
        "01:00 pm to 01:30 pm",
        "01:30 pm to 02:00 pm",
        "02:00 pm to 02:30 pm",
        "02:30 pm to 03:00 pm",
        "03:00 pm to 03:30 pm",
        "03:30 pm to 04:00 pm",
        "04:00 pm to 04:30 pm",
        "04:30 pm to 05:00 pm",
        "05:00 pm to 05:30 pm",
        "05:30 pm to 06:00 pm",
        "06:00 pm to 06:30 pm",
        "06:30 pm to 07:00 pm",
        "07:00 pm to 07:30 pm",
        "07:30 pm to 08:00 pm",
        "08:00 pm to 08:30 pm",
        "08:30 pm to 09:00 pm",
      ]);
    } else {
      setTimeOptions([]); 
    }
    setTime(""); 
  }, [branch]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const db = firebase.database();

    try {
      const newId = latestId + 1;

      // Reformat the date to DD/MM/YYYY format
      const formattedDate = date.split("-").reverse().join("/");

      // Push form data to the database
      await db.ref("Appointment Form").push({
        Appointment_id: newId,
        Appointment_fname: fname,
        Appointment_lname: lname,
        Appointment_date: formattedDate,
        Appointment_pnumber: pnumber,
        Appointment_message: message,
        Appointment_branch: branch,
        Appointment_time: time,
      });

      setfName("");
      setlName("");
      setDate("");
      setPnumber("");
      setMessage("");
      setBranch("");

      setFeedbackMessage("Appointment Form submitted successfully!");
    } catch (error) {
      console.error("Error storing form data:", error);
      setFeedbackMessage("Failed to send Appointment. Please try again.");
    }
  };

  return (
    <div className="ftco-section ftco-appointment">
      <div className="overlay" />
      <div className="container">
        <div className="row d-md-flex align-items-center">
          <div className="col-md-2" />
          <div className="col-md-4 d-flex align-self-stretch ftco-animate">
            <div className="appointment-info text-center p-5">
              <div className="mb-1">
                <h3 className="mb-2 blackthemegradient">Address-1</h3>
                <p>Rajiv Gandhi Salai, Sholinganallur, Chennai - 600097</p>
                <h6 className="mb-1 blackthemegradient">Opening Hours</h6>
                <p className="day">
                  <strong>Monday - Sunday</strong>
                </p>
                <span>10:00am - 09:00pm</span>
                <h3 className="p-2 mb-2 blackthemegradient">Address-2</h3>
                <p>200-A, Mambakkam- Medavakkam Main Rd,Medavakkam, Chennai</p>
                <h6 className="mb-1 blackthemegradient">Opening Hours</h6>
                <p className="day">
                  <strong>Monday - Sunday</strong>
                </p>
                <span>10:00am - 08:30pm</span>
              </div>
              <div className="mb-4">
                <h3 className="mb-2 blackthemegradient">Phone</h3>
                <p className="day">
                  <strong>9841424435</strong> or <strong>9962742919</strong>
                </p>
              </div>
              {/* <div>
                <h3 className="mb-3">Opening Hours</h3>
                <p className="day">
                  <strong>Monday - Saturday</strong>
                </p>
                <span>10:00am - 09:00pm</span>
              </div> */}
            </div>
          </div>
          <div className="col-md-6 appointment pl-md-5 ftco-animate">
            <h2 className="mb-3 blackthemegradient">Appointments</h2>
            <form onSubmit={handleSubmit} className="appointment-form">
              <div className="row form-group d-flex">
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="First Name"
                    value={fname}
                    onChange={(e) => setfName(e.target.value)}
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Last Name"
                    value={lname}
                    onChange={(e) => setlName(e.target.value)}
                  />
                </div>
              </div>
              <div className="row form-group d-flex">
                <div className="col-md-6">
                  <div className="input-wrap">
                    <div className="icon">
                      <span className="ion-md-calendar" />
                    </div>
                    <input
                      type="date"
                      id="appointment_date"
                      className="form-control"
                      value={date}
                      onChange={(e) => setDate(e.target.value)}
                    />

                  </div>
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Phone"
                    value={pnumber}
                    onChange={(e) => setPnumber(e.target.value)}
                  />
                </div>
               
              </div>
              <div className="row form-group d-flex">
              <div className="col-md-6">
                  <select
                    className="form-control"
                    value={branch}
                    onChange={(e) => setBranch(e.target.value)}
                  >
                    <option value="" disabled>
                      Select Branch
                    </option>
                    <option style={{color: "black"}} value="Medavakkam">Medavakkam</option>
                    <option style={{color: "black"}} value="Sholinganallur">Sholinganallur</option>
                  </select>
                </div>
              <div className="col-md-6">
                  <select
                    className="form-control"
                    value={time}
                    onChange={(e) => setTime(e.target.value)}
                    disabled={!branch}
                  >
                    <option value="" disabled>
                      {branch ? "Select Time" : "Select Branch First"}
                    </option>
                    {timeOptions.map((timeOption, index) => (
                      <option key={index} className="timeoptions" value={timeOption}>
                        {timeOption}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="form-group">
                <textarea
                  cols={30}
                  rows={3}
                  className="form-control"
                  placeholder="Message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>
              <div className="form-group">
                <input
                  type="submit"
                  value="Submit"
                  className="btn py-3 px-4 buttoncolor text-white"

                />
              </div>
              {feedbackMessage && (
                <div
                  className={`alert ${
                    feedbackMessage.includes("successfully")
                      ? "alert-success"
                      : "alert-danger"
                  }`}
                  role="alert"
                >
                  {feedbackMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Appointment;
